import { apiClient } from '../../axios';
import { ReqPagination } from '../../types';
import {
  CopyTradeCopyStatus,
  CopyTradeMyCopyDetail,
  CopyTradeMyCopyStopEstimation,
  GetCopyTradeEstimatedProfitShareResponse,
  GetCopyTradeFailedOrdersResponse,
  GetCopyTradeFundingHistoryResponse,
  GetCopyTradeHistoryResponse,
  GetCopyTradeMeResponse,
  GetCopyTradeMyCopiesResponse,
  GetCopyTradeMyCopyPositionsResponse,
  GetCopyTradePortfolioCopiersResponse,
  GetCopyTradePortfolioSetupResponse,
  GetCopyTradePortfoliosResponse,
  GetCopyTradeProfitSharedResponse,
  GetCopyTradeSummaryResponse,
  GetCopyTradeTransfersParams,
  GetCopyTradeTransfersResponse,
  PostCopyTradeAddBalanceRequest,
  PostCopyTradeAddBalanceResponse,
  PostCopyTradeApplyMasterRequest,
  PostCopyTradePortfolioCopyRequest,
  PostCopyTradePortfolioCopyResponse,
  PostCopyTradePortfolioSetupRequest,
  PostCopyTradeReduceBalanceRequest,
  PostCopyTradeReduceBalanceResponse,
} from './types';

export const postCopyTradePortfolioCopyApi = (portfolioId: string, params: PostCopyTradePortfolioCopyRequest) =>
  apiClient.post<PostCopyTradePortfolioCopyResponse>(`/v1/copy-trade/portfolio/${portfolioId}/copy`, params);

export const getCopyTradeMeApi = () => apiClient.get<GetCopyTradeMeResponse>('/v1/copy-trade/me');

export const getCopyTradePortfoliosApi = () =>
  apiClient.get<GetCopyTradePortfoliosResponse>('/v1/copy-trade/portfolios');

export const getCopyTradePortfolioCopiersApi = (
  portfolioId: string,
  params: { rankAfter?: number; count?: number; orderBy?: 'pnlDesc' | 'fundDesc' | 'roiDesc' },
) => apiClient.get<GetCopyTradePortfolioCopiersResponse>(`/v1/copy-trade/portfolio/${portfolioId}/copiers`, { params });

export const postCopyTradeStopApi = (portfolioId: string) =>
  apiClient.post(`/v1/copy-trade/copies/${portfolioId}/stop`);

// history
export const getCopyTradeFailedOrdersApi = (
  portfolioCopyId: string,
  params?: { count?: number; before?: string; after?: string },
) =>
  apiClient.get<GetCopyTradeFailedOrdersResponse>(`/v1/copy-trade/copies/${portfolioCopyId}/failed-orders`, { params });

export const getCopyTradeHistoryApi = (
  portfolioCopyId: string,
  params?: { count?: number; before?: string; after?: string },
) => apiClient.get<GetCopyTradeHistoryResponse>(`/v1/copy-trade/copies/${portfolioCopyId}/history`, { params });

export const getCopyTradeMyCopyDetailApi = (portfolioCopyId: string) =>
  apiClient.get<CopyTradeMyCopyDetail>(`/v1/copy-trade/copies/${portfolioCopyId}`);

export const getCopyTradeMyCopyStopEstimationApi = (portfolioCopyId: string) =>
  apiClient.get<CopyTradeMyCopyStopEstimation>(`/v1/copy-trade/copies/${portfolioCopyId}/stop-estimation`);

export const getCopyTradeMyCopyPositionsApi = (
  portfolioCopyId: string,
  params?: { count?: number; before?: string; after?: string },
) =>
  apiClient.get<GetCopyTradeMyCopyPositionsResponse>(`/v1/copy-trade/copies/${portfolioCopyId}/positions`, { params });

export const getCopyTradeProfitSharedApi = (
  portfolioCopyId: string,
  params?: { count?: number; before?: string; after?: string },
) =>
  apiClient.get<GetCopyTradeProfitSharedResponse>(`/v1/copy-trade/copies/${portfolioCopyId}/profit-shared`, { params });

export const getCopyTradeFundingHistoryApi = (
  portfolioCopyId: string,
  params?: { count?: number; before?: string; after?: string },
) =>
  apiClient.get<GetCopyTradeFundingHistoryResponse>(`/v1/copy-trade/copies/${portfolioCopyId}/funding-history`, {
    params,
  });

export const getCopyTradeTransfersByIdApi = (
  portfolioCopyId: string,
  params?: { count?: number; before?: string; after?: string },
) => apiClient.get<GetCopyTradeTransfersResponse>(`/v1/copy-trade/copies/${portfolioCopyId}/transfers`, { params });

export const getCopyTradeTransfersApi = (params?: GetCopyTradeTransfersParams) =>
  apiClient.get<GetCopyTradeTransfersResponse>('/v1/copy-trade/transfers', { params });

export const getCopyTradeMyCopiesApi = (status: CopyTradeCopyStatus, params?: ReqPagination) =>
  apiClient.get<GetCopyTradeMyCopiesResponse>('/v1/copy-trade/copies', { params: { status, ...params } });

// Balance APIs
export const postCopyTradeAddBalanceApi = (portfolioCopyId: string, params: PostCopyTradeAddBalanceRequest) =>
  apiClient.post<PostCopyTradeAddBalanceResponse>(`/v1/copy-trade/copies/${portfolioCopyId}/add-balance`, params);

export const postCopyTradeReduceBalanceApi = (portfolioCopyId: string, params: PostCopyTradeReduceBalanceRequest) =>
  apiClient.post<PostCopyTradeReduceBalanceResponse>(`/v1/copy-trade/copies/${portfolioCopyId}/reduce-balance`, params);

export const getCopyTradeEstimatedProfitShareApi = (portfolioCopyId: string) =>
  apiClient.get<GetCopyTradeEstimatedProfitShareResponse>(
    `/v1/copy-trade/copies/${portfolioCopyId}/estimated-profit-share`,
  );

export const getCopyTradeSummaryApi = () => apiClient.get<GetCopyTradeSummaryResponse>('/v1/copy-trade/summary');

export const postVerifyInvitationCodeApi = (portfolioId: string, params: { invitationCode: string }) =>
  apiClient.post(`/v1/copy-trade/portfolio/${portfolioId}/verify-invitation-code`, params);

// Apply master trader
export const postCopyTradeApplyMasterApi = (params: PostCopyTradeApplyMasterRequest) =>
  apiClient.post('/v1/copy-trade/apply-master', params);

// Portfolio setup
export const getCopyTradePortfolioSetupApi = (portfolioId: string) =>
  apiClient.get<GetCopyTradePortfolioSetupResponse>(`/v1/copy-trade/portfolio/${portfolioId}/setup`);

export const postCopyTradePortfolioSetupApi = (portfolioId: string, params: PostCopyTradePortfolioSetupRequest) =>
  apiClient.post(`/v1/copy-trade/portfolio/${portfolioId}/setup`, params);
